var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.$currentUserCan(_vm.$permissions.PERM_VIEW_ANY_CONTACTS) && _vm.contact
  )?_c('div',[_c('router-link',{attrs:{"to":_vm.$objectViewRoute(_vm.contact)}},[_vm._v(" "+_vm._s(`${_vm.contact.firstname && _vm.contact.lastname ? _vm.contact.firstname+' '+_vm.contact.lastname : _vm.contact.company_name}`)+_vm._s(_vm.contact.firstname ? '-'+`${_vm.contact.firstname}` : '')+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }